<template>
  <div>
    <van-row
      type="flex"
      justify="center"
      style="background: linear-gradient(45deg,rgba(254,172,94,0.5),rgba(199,121,208,0.5),rgba(75,192,200,0.5)); height: 100px; line-height: 100px;"
    >
      <van-col span="8" />
      <van-col span="8"><van-image width="10rem" height="6rem" fit="contain" src="../../../static/logo.png" /></van-col>
      <van-col span="8" />
    </van-row>
    <van-divider :style="{ color: 'green', borderColor: 'green', padding: '0 16px' }">春雪宣传图</van-divider>
    <van-row type="flex" justify="space-between" style=" text-align: center; margin-top: 1rem; ">
      <van-col span="11" style="margin-left: 0.6rem;"><van-button size="large" color="linear-gradient(to right, skyblue, skyblue)" @click="insert">新增列表</van-button></van-col>
      <van-col span="11" style="margin-right: 0.6rem;"><van-button color="#9f9f9f" plain size="large" type="default" @click="queryx">清空查询</van-button></van-col>
    </van-row>

    <van-row type="flex" justify="space-between" style=" text-align: center; margin-top: 1rem; ">
      <van-col span="11" style="margin-left: 0.6rem;">
        <van-button size="large" type="primary" @click="show5 = true">{{ client_type_qr }}</van-button>
      </van-col>
      <van-col span="11" style="margin-right: 0.6rem;">
        <van-button size="large" type="info" @click="show4 = true">{{ file_type_qr }}</van-button>
      </van-col>
    </van-row>
    <van-swipe-cell style="border: 1px solid #FCF8E3;margin: 4px;"><van-cell :border="false" title="名称" value="文案" /></van-swipe-cell>
    <van-swipe-cell v-for="list in publicity" :key="list.id" style="border: 1px solid #F0F0F0;margin: 4px;">
      <template #left>
        <van-button square type="primary" text="上传" @click="(up = true), upx(list)" />
      </template>

      <van-cell
        :border="false"
        :title="list.name"
        :data-clipboard-text="list.name"
        :value="list.comment | ellipsis"
        style="height: 44px;"
        class="tag-read"
        @click="fileListX(list), copy()"
      />

      <van-row type="flex" justify="center" style=" overflow: hidden;">
        <van-col v-for="(listx, index) in imagesUrlListS" v-if="listx.id == list.id" :key="index" span="4" @click="fileListX(list)">
          <van-image :src="listx.src" style="left: 4px; border: 1px solid #DFF0D8; width: 50px;height: 50px;" fit="contain" />
        </van-col>
      </van-row>
      <template #right>
        <van-button square type="danger" text="删除" @click="delX(list)" />
        <van-button square type="primary" text="修改" @click="modifyX(list)" />
      </template>
    </van-swipe-cell>

    <div>
      <van-popup v-model="up" closeable round style="width: 300px;height: 300px;">
        <van-uploader
          v-model="fileList"
          :max-count="99"
          :disabled="!canUpload"
          :deletable="canUpload"
          :after-read="afterRead"
          :before-delete="beforeDelete"
          accept="*"
          upload-text="请选择文件"
          multiple
        />
      </van-popup>
    </div>
    <div>
      <van-popup v-model="show" closeable round style="width: 400px;">
        <div v-for="(File, index) in FileListImag" :key="File.id" style=" padding-left:5%;">
          <span v-if="index == 0" style="height: 40px;display: block;" />
          <van-row type="flex" justify="center">
            <van-col span="20">
              <viewer id="imageUrlsCourseSource " z-index-inline="4000"><img :src="File.src" :key="File.id" width="350" height="150" @click="show = false" ></viewer>
            </van-col>
            <van-col span="4"><van-button size="mini" plain hairline type="danger" style="margin-left: 33px;height: 40px;" @click="del(File)">删除</van-button></van-col>
          </van-row>
        </div>
      </van-popup>
    </div>

    <div>
      <van-popup v-model="show2" closeable round style="width: 400px;padding-top: 14px;">
        <van-row type="flex" justify="center" style=" text-align: center;"><van-col span="24">修改</van-col></van-row>
        <van-cell-group>
          <van-field v-model="value1" label="名称" left-icon="browsing-history-o" right-icon="warning-o" placeholder="请输入新的名称" />
          <van-field v-model="fxValue" is-link readonly left-icon="notes-o" label="内容类别" placeholder="请选择" @click="show1 = true" />
          <van-field v-model="fxValue_x" is-link readonly left-icon="contact" label="客户状态" placeholder="请选择" @click="show6 = true" />
          <van-field v-model="value2" clearable label="备注" left-icon="comment-o" placeholder="备注" />
        </van-cell-group>
        <van-button type="primary" size="large" @click="save()">保存</van-button>
      </van-popup>
    </div>
    <!-- 新增 -->
    <div>
      <van-popup v-model="show3" closeable round style="width: 400px;padding-top: 14px;">
        <van-row type="flex" justify="center" style=" text-align: center;"><van-col span="24">新增</van-col></van-row>
        <van-form @submit="addpub">
          <van-cell-group>
            <van-field v-model="value3" :rules="[{ required: true, message: '' }]" label="名称" left-icon="browsing-history-o" right-icon="warning-o" placeholder="请输入名称" />
            <van-field
              v-model="fieldValue"
              :rules="[{ required: true, message: '' }]"
              is-link
              readonly
              left-icon="notes-o"
              label="内容类别"
              placeholder="请选择"
              @click="show1 = true"
            />
            <van-field
              v-model="fieldValue_x"
              :rules="[{ required: true, message: '' }]"
              is-link
              readonly
              left-icon="contact"
              label="客户状态"
              placeholder="请选择"
              @click="show6 = true"
            />
            <van-field v-model="value4" clearable label="备注" left-icon="comment-o" placeholder="备注" />
          </van-cell-group>
          <van-button type="primary" size="large" native-type="submit">保存</van-button>
        </van-form>
      </van-popup>
      <van-popup v-model="show1" round position="bottom">
        <van-cascader v-model="cascaderValue" :options="options" title="请选择" @close="show1 = false" @finish="onFinish" />
      </van-popup>
      <van-popup v-model="show6" round position="bottom">
        <van-cascader v-model="cascaderValue2" :options="option2" title="请选择" @close="show6 = false" @finish="onFinishS" />
      </van-popup>

      <van-popup v-model="show4" round position="bottom">
        <van-cascader v-model="cascaderValue" :options="options" title="请选择" @close="show4 = false" @finish="onFinish_query" />
      </van-popup>
      <van-popup v-model="show5" round position="bottom">
        <van-cascader v-model="cascaderValue" :options="option2" title="请选择" @close="show5 = false" @finish="onFinish_query_x" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { getpublicityist, uploadx, deleteFileX, getfilelist, modify, deletepub, add } from '@/api/publicity';
import Clipboard from 'clipboard';
import Vue from 'vue';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import { mapGetters } from 'vuex';
import { Toast } from 'vant';
// import { Cascader } from 'vant';

// Vue.use(Cascader);
Vue.use(Toast);
Vue.use(Viewer);
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
});
export default {
  name: 'Publicity',
  filters: {
    ellipsis(value) {
      if (!value) return '';
      if (value.length > 28) {
        return value.slice(0, 28) + '...';
      }
      return value;
    }
  },
  data() {
    return {
      show1: false,
      fxValue_x: '',
      show6: false,
      cascaderValue2: '',
      fieldValue: '',
      cascaderValue: '',
      fxValue: '',
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: '产品介绍',
          value: '1',
          children: [{ text: '代账周期性产品', value: '11' }, { text: '代账一次性产品', value: '12' }, { text: '人力产品', value: '13' }]
        },
        {
          text: '营销活动',
          value: '2',
          children: [{ text: '周期性产品活动', value: '21' }, { text: '一次性产品活动', value: '22' }]
        },
        {
          text: '品牌宣传',
          value: '3',
          children: [{ text: '品牌宣传', value: '31' }, { text: '热点新闻', value: '32' }, { text: '节假日祝福', value: '33' }]
        },
        {
          text: '客户服务',
          value: '4',
          children: [{ text: '温馨提示', value: '41' }, { text: '调查问卷', value: '42' }]
        }
      ],
      option2: [
        {
          text: '通用内容',
          value: '9',
          children: [
            { text: '代账周期性产品', value: '91' },
            { text: '代账一次性产品', value: '92' },
            { text: '人力产品', value: '93' },
            { text: '周期性产品活动', value: '94' },
            { text: '一次性产品活动', value: '95' },
            { text: '品牌宣传', value: '96' },
            { text: '热点新闻', value: '97' },
            { text: '节假日祝福', value: '98' },
            { text: '温馨提示', value: '99' },
            { text: '调查问卷', value: '100' }
          ]
        },
        {
          text: '潜在客户',
          value: '5',
          children: [
            { text: '代账周期性产品', value: '51' },
            { text: '代账一次性产品', value: '52' },
            { text: '人力产品', value: '53' },
            { text: '周期性产品活动', value: '54' },
            { text: '一次性产品活动', value: '55' },
            { text: '品牌宣传', value: '56' },
            { text: '热点新闻', value: '57' },
            { text: '节假日祝福', value: '58' },
            { text: '温馨提示', value: '59' },
            { text: '调查问卷', value: '60' }
          ]
        },
        {
          text: '签约客户',
          value: '6',
          children: [
            { text: '代账周期性产品', value: '61' },
            { text: '代账一次性产品', value: '62' },
            { text: '人力产品', value: '63' },
            { text: '周期性产品活动', value: '64' },
            { text: '一次性产品活动', value: '65' },
            { text: '品牌宣传', value: '66' },
            { text: '热点新闻', value: '67' },
            { text: '节假日祝福', value: '68' },
            { text: '温馨提示', value: '69' },
            { text: '调查问卷', value: '70' }
          ]
        },
        {
          text: '服务维护',
          value: '10',
          children: [
            { text: '代账周期性产品', value: '101' },
            { text: '代账一次性产品', value: '102' },
            { text: '人力产品', value: '103' },
            { text: '周期性产品活动', value: '104' },
            { text: '一次性产品活动', value: '105' },
            { text: '品牌宣传', value: '106' },
            { text: '热点新闻', value: '107' },
            { text: '节假日祝福', value: '108' },
            { text: '温馨提示', value: '109' },
            { text: '调查问卷', value: '110' }
          ]
        },
        {
          text: '终止合作',
          value: '7',
          children: [
            { text: '代账周期性产品', value: '71' },
            { text: '代账一次性产品', value: '72' },
            { text: '人力产品', value: '73' },
            { text: '周期性产品活动', value: '74' },
            { text: '一次性产品活动', value: '75' },
            { text: '品牌宣传', value: '76' },
            { text: '热点新闻', value: '77' },
            { text: '节假日祝福', value: '78' },
            { text: '温馨提示', value: '79' },
            { text: '调查问卷', value: '80' }
          ]
        },
        {
          text: '客户回头',
          value: '8',
          children: [
            { text: '代账周期性产品', value: '81' },
            { text: '代账一次性产品', value: '82' },
            { text: '人力产品', value: '83' },
            { text: '周期性产品活动', value: '84' },
            { text: '一次性产品活动', value: '85' },
            { text: '品牌宣传', value: '86' },
            { text: '热点新闻', value: '87' },
            { text: '节假日祝福', value: '88' },
            { text: '温馨提示', value: '89' },
            { text: '调查问卷', value: '90' }
          ]
        }
      ],
      ifow: 0,
      fieldValue_x: '',
      up: false,
      value1: '',
      value3: '',
      value4: '',
      show3: false,
      value2: '',
      showDatePicker: false,
      showDetails: false,
      showPreview: false,
      active: 0,
      activeHistory: 0,
      activeTabbar: 'upload',
      uploading: false,
      uploadingMsg: '',
      uploadingPercentage: 0,
      tip: this.CONST.EMPTY_MSG,
      canUpload: false,
      ym: '',
      file_type_qr: '内容类别',
      client_type_qr: '客户状态',
      file_type_md: '',
      client_type_md: '',
      show2: false,
      client_type_id: 0,
      selectedDate: null,
      elecnotesList: [],
      imagesUrlList: [],
      imagesUrlListS: [],
      startPosition: 0,
      IdX: 0,
      file_type_id: 0,
      fileOrd: 1,
      uploadData: {
        id: 0
        // id: 1
      },
      steps: [
        {
          id: '1',
          name: '上月完税',
          fileList: [],
          historyOtherList: [],
          historyImageList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '2',
          name: '本月收入票',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '3',
          name: '银行收付',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '4',
          name: '成本费用票',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        },
        {
          id: '5',
          name: '辅助资料',
          fileList: [],
          historyFileList: [],
          hasError: false,
          errorMsg: ''
        }
      ],
      initStates: [
        {
          key: 'app/initCurrentDate'
        }
      ],
      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.ROWS,
        sort: 'id',
        order: 'desc',
        client_name: '',
        file_type_id: 0,
        client_type_id: 0,
        name: ''
      },
      show5: false,
      show4: false,
      publicity: [],
      fileList: [],
      show: false,
      FileListImag: [],
      BACKEND_API: this.BACKEND_API
    };
  },
  computed: {
    ...mapGetters(['token', 'userInfo', 'currentDate', 'selectedClient'])
  },
  mounted() {
    this.query();
    this.canUpload = true;
    this.iterator();
    // console.log(this.options[4].children[0].children);
  },
  methods: {
    insert() {
      this.show3 = true;
      this.fxValue = '';
      this.fieldValue = '';
      this.fieldValue_x = '';
      this.fxValue_x = '';
    },
    iterator() {
      for (var i = 0; i < this.options.length; i++) {
        for (var x = 0; x < this.options[i].children.length; x++) {
          if (this.file_type_md == this.options[i].children[x].value) {
            this.fxValue = this.options[i].text + '/' + this.options[i].children[x].text;
          }
          // else {

          // }
        }
      }

      for (var c = 0; c < this.option2.length; c++) {
        for (var w = 0; w < this.option2[c].children.length; w++) {
          // for (var a = 0; a < this.option2[c].children[x].children.length; a++) {
          // console.log(this.option2[c].children[w].children[a].value);
          if (this.client_type_md == this.option2[c].children[w].value) {
            this.fxValue_x = this.option2[c].text + '/' + this.option2[c].children[w].text;
          }
          // }
        }
      }
    },
    onFinish({ value, selectedOptions, tabIndex }) {
      this.show1 = false;

      this.fieldValue = selectedOptions.map(option => option.text).join('/');
      this.fxValue = selectedOptions.map(option => option.text).join('/');

      this.file_type_id = value;
    },
    onFinishS({ value, selectedOptions, tabIndex }) {
      this.show6 = false;
      this.fxValue_x = selectedOptions.map(option => option.text).join('/');
      this.cascaderValue2 = selectedOptions.map(option => option.text).join('/');
      this.fieldValue_x = selectedOptions.map(option => option.text).join('/');
      this.client_type_id = value;
    },
    onFinish_query({ value, selectedOptions, tabIndex }) {
      this.show4 = false;
      this.file_type_qr = selectedOptions.map(option => option.text).join('/');
      this.queryCondition.file_type_id = parseInt(value);
      this.query();
    },
    onFinish_query_x({ value, selectedOptions, tabIndex }) {
      this.show5 = false;
      this.client_type_qr = selectedOptions.map(option => option.text).join('/');
      this.queryCondition.client_type_id = parseInt(value);
      this.query();
    },
    copy() {
      var clipboard = new Clipboard('.tag-read');
      clipboard.on('success', e => {
        Toast.success('已复制文本');
        // 释放内存
        console.info('Text:', e.text);

        clipboard.destroy();
      });
      clipboard.on('error', e => {
        // 不支持复制
        console.info('Text:', e.text);
        Toast.fail('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
      });
    },
    initImageTools() {
      // 初始化 viewerjs
      const ViewerDom = document.getElementById('imageUrlsCourseSource');
      new Viewer(ViewerDom, {
        // 相关配置项,详情见下面
        zIndex: 3018
      });
      const viewer = new Viewer(ViewerDom, { url: 'src' });
    },
    addpub() {
      add({
        file_type_id: parseInt(this.file_type_id),
        client_type_id: parseInt(this.client_type_id),
        name: this.value3,
        comment: this.value4
      }).then(res => {
        if (res.success) {
          this.show3 = false;
          this.fieldValue = '';
          this.fieldValue_x = '';
          this.value3 = '';
          this.value4 = '';
          this.query();
        }
        Toast(res.msg);
      });
    },
    delX(val) {
      deletepub({
        id: val.id
      }).then(res => {
        if (res.success) {
          this.query();
          this.show2 = false;
          // this.toast(res.data.msg);
        }
      });
    },
    save() {
      modify({
        name: this.value1,
        comment: this.value2,
        file_type_id: parseInt(this.file_type_id),
        client_type_id: parseInt(this.client_type_id),
        id: this.IdX
      }).then(res => {
        if (res.success) {
          this.show2 = false;
          this.query();
        }
        Toast(res.msg);
      });
    },
    modifyX(val) {
      this.show2 = true;
      this.value1 = val.name;
      this.value2 = val.comment;
      this.file_type_md = val.file_type_id;
      this.client_type_md = val.client_type_id;
      this.file_type_id = val.file_type_id;
      this.client_type_id = val.client_type_id;

      if (this.file_type_md == '0') {
        this.fxValue = '请选择';
      }
      if (this.client_type_md == '0') {
        this.fxValue_x = '请选择';
      } else {
        this.iterator();
      }

      this.IdX = val.id;
    },
    fileListX(val) {
      if (val.file_ids !== undefined) {
        this.show = true;
        this.uploadData.file_ids = val.file_ids;
        this.uploadData.ixd = val.id;
        this.getfileListS(this.uploadData.file_ids);
      } else {
        // this.toast('暂无数据');
      }
    },
    upx(val) {
      this.up = true;
      this.uploadData.id = val.id;
    },
    del(File) {
      return new Promise((resolve, reject) => {
        deleteFileX({
          file_id: File.id,
          id: this.uploadData.ixd
        }).then(resp => {
          if (resp.success) {
            resolve();
            this.show = false;
            Toast.success(resp.msg);

            this.fileListX(File);
            this.query();
          } else {
            reject();
          }
        });
      });
    },
    getfileListS(val) {
      if (val.length === 0) {
        val = '0';
        Toast.fail('暂无图片');
      }
      this.FileListImag = [];
      getfilelist({ ids: val, rows: 999999 }).then(res => {
        if (res.rows.length !== null) {
          const len = res.rows.length;
          const rex = res.rows;
          for (let i = 0; i < len; i++) {
            this.FileListImag.push({
              id: rex[i].id,
              path: rex[i].path,
              token: this.token,
              src: this.BACKEND_API + '/' + rex[i].path + '?token=' + this.token
            });
          }
        }
      });
    },
    beforeDelete(file) {
      return new Promise((resolve, reject) => {
        deleteFileX({
          file_id: file.obj.id,
          id: this.uploadData.id
        }).then(resp => {
          if (resp.success) {
            resolve();
            Toast.success(resp.msg);
            this.query();
          } else {
            reject();
          }
        });
      });
    },
    async afterRead(file) {
      this.canUpload = false;
      this.uploading = true;
      this.uploadingPercentage = 0;
      let files = [];
      // console.log(file.file.name);
      // this.ym = file.file.name;
      if (file instanceof Array) {
        files = file;
      } else {
        files.push(file);
      }
      for (let i = 0; i < files.length; i++) {
        this.uploadingPercentage = parseFloat(parseFloat(((i + 1) / files.length) * 100).toFixed(2));
        this.uploadingMsg = ` ${i + 1}/${files.length}`;
        const originFile = files[i];
        const suffixPos = originFile.file.name.lastIndexOf('.');
        const suffixName = originFile.file.name.substring(suffixPos + 1);
        const isImg = this.CONST.IMAGE_TYPES.find(type => type === suffixName) != null;

        if (isImg) {
          const rst = await this.lrz(originFile.file);
          await this.uploadFile(originFile, rst.formData, this.fileOrd++).catch(() => {
            this.error('文件上传失败');
          });
        } else {
          const formData = new FormData();
          formData.append('file', originFile.file);
          formData.append('id', this.uploadData.id);
          await this.uploadFile(originFile, formData, this.fileOrd++).catch(() => {
            this.error('文件上传失败');
          });
        }
      }
      this.canUpload = true;
      this.uploading = false;
      this.uploadingPercentage = 100;
    },
    uploadFile(originFile, formData, ord) {
      return new Promise((resolve, reject) => {
        for (const key in this.uploadData) {
          formData.append(key, this.uploadData[key]);
        }
        formData.append('token', this.token);
        // formData.append('ym', this.ym);
        uploadx(formData)
          .then(resp => {
            if (resp.success) {
              if (resp.obj) {
                originFile.obj = resp.obj;
                this.uploadData.ele_id = resp.obj.ele_id;
              }
              console.log('文件上传成功 ord: ', ord);
              this.success(resp.msg);
              this.query();
              resolve();
            } else {
              console.error('文件上传失败 ord: ', ord);
              this.delFile(originFile);
              reject(resp.msg);
            }
          })
          .catch(error => {
            console.error('文件上传失败 ord: ', ord);
            this.delFile(originFile);
            reject(error.message);
          });
      });
    },
    delFile(step, file) {
      const index = step.fileList.indexOf(file);
      if (index !== -1) {
        step.fileList.splice(index, 1);
        console.log('删除成功');
      }
    },
    queryx() {
      this.queryCondition.file_type_id = 0;
      this.queryCondition.client_type_id = 0;
      this.file_type_qr = '内容类别';
      this.client_type_qr = '客户状态';

      this.query();
    },
    query() {
      this.publicity = [];
      this.imagesUrlListS = [];
      this.queryCondition.rows = 999999;
      // this.queryCondition
      getpublicityist(this.queryCondition).then(res => {
        const len = res.rows.length;
        const rex = res.rows;
        for (let i = 0; i < len; i++) {
          this.publicity.push({
            id: rex[i].id,
            name: rex[i].name,
            comment: rex[i].comment,
            file_type_id: rex[i].file_type_id,
            client_type_id: rex[i].client_type_id,
            file_ids: rex[i].file_ids
          });
        }
      });
      getfilelist({ ids: '', rows: 999999 }).then(res => {
        if (res.total >= 0) {
          const len = res.rows.length;

          const rex = res.rows;
          let x = 0;
          if (len < 6) {
            for (let i = 0; i < len; i++) {
              const id = rex[i].path.split('/');
              this.imagesUrlListS.push({
                id: id[2],
                src: this.BACKEND_API + '/' + rex[i].path + '?token=' + this.token
              });
            }
          } else {
            for (let i = len - 1; i >= 0; i--) {
              ++x;
              if (x <= 6) {
                const id = rex[i].path.split('/');
                this.imagesUrlListS.push({
                  id: id[2],
                  src: this.BACKEND_API + '/' + rex[i].path + '?token=' + this.token
                });
              }
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.van-uploader {
  margin-left: 40%;
  margin-top: 20%;
}
.contentBox,
.contentBox p {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
.goods-card {
  margin: 0;
  background-color: white;
}

.delete-button {
  height: 100%;
}
.tag-read >>> .van-cell__value {
  text-align: right;
  height: 44px;
  margin-top: -10px;
  padding: 0px;
  top: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/publicity/publicity.vue